import { Avatar, makeStyles } from '@fluentui/react-components';
import type { ReactNode } from 'react';

import { initialsOf } from '../common';
import { tokens } from '../theme';
import { useMemberAvatar } from './use-member-avatar';

export type MemberIdentityProps = {
    name: string;
    email: string;
    size?: 24 | 32 | 40 | 48 | 56;
    secondary?: ReactNode;
    nameClassName?: string;
};

export const MemberIdentity: React.FC<MemberIdentityProps> = ({ name, email, size = 48, secondary, nameClassName }) => {
    const classes = useStyles();
    const avatarUrl = useMemberAvatar(email);
    return (
        <>
            <Avatar name={name} image={avatarUrl ? { src: avatarUrl } : undefined} initials={initialsOf(name)} size={size} />
            <div className={classes.who}>
                <h3 className={nameClassName ?? classes.name}>{name}</h3>
                {secondary}
            </div>
        </>
    );
};

const useStyles = makeStyles({
    who: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: 0,
    },
    name: {
        margin: 0,
        fontSize: '16px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
});
